import { createContext } from 'react';
/** Context surrounding the current frame that provides MSRC's auth */
export const authContext = createContext({});
